var map = {
	"./1-1.png": "3fa6",
	"./2-1.png": "2fd0",
	"./3-1.png": "93c6",
	"./4-1.png": "d194",
	"./5-1.png": "d64b",
	"./6-1.png": "28c8",
	"./7-1.png": "b044"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4163";